// oxlint-disable-next-line no-unassigned-import
import './index.css'

import EnvConfigProvider from '@contexts/EnvConfigProvider'
import { ThemeContextProvider } from '@contexts/ThemeContext'
// TODO(pascal): Actually create the store in the App, not here.
import store from '@store/store'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'

import App from './App'

// eslint-disable-next-line @typescript-eslint/no-non-null-assertion
const root = createRoot(document.getElementById('root')!)

root.render(
	<React.StrictMode>
		<Provider store={store}>
			<EnvConfigProvider>
				<ThemeContextProvider>
					<App />
				</ThemeContextProvider>
			</EnvConfigProvider>
		</Provider>
	</React.StrictMode>
)
